import React, { useEffect, useState } from 'react';
import BasicButtons from '../../Common/BasicButtons';
import CashoutAddBankOptions from './CashoutAddBankOption';
import { hot } from 'react-hot-loader';

const CashoutBankOptions = ({
	bankAccountsForCashout,
	banks,
	handleCashoutChooseOption,
	currentUser,
	setCurrentUser,
	classes
}) => {
	const [addModal, setAddModal] = useState(false);
	const [addIndex, setAddIndex] = useState(null);
	const [bankAccounts, setBankAccounts] = useState(bankAccountsForCashout || []);

	const PlusCashout = `${process.env.PUBLIC_URL + 'images/plus.png'}`;
	const ExclamationMarkCashout = `${process.env.PUBLIC_URL + 'images/exclamation_mark_cashoout.png'}`;

	const handleModal = index => {
		setAddModal(prev => !prev);
		setAddIndex(index);
	};

	useEffect(() => {
		if (addModal) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = 'auto';
		}

		// Cleanup function to restore scroll
		return () => {
			document.body.style.overflow = 'auto';
		};
	}, [addModal]);

	const overlay = {
		position: 'fixed',
		width: '100vw',
		height: '100vh',
		backgroundColor: 'rgba(0, 0, 0, 0.5)',
		top: 0,
		left: 0,
		backdropFilter: 'blur(5px)',
		zIndex: 100
	};

	return (
		<div>
			{banks.length > 0 &&
				bankAccounts.map((v, i) => {
					return (
						<BasicButtons
							key={i}
							bgColor={v.bgColor}
							opac={v.opac}
							inverted={banks[i].isClicked}
							border={v.border}
							text={
								v.bank ? (
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											whiteSpace: 'nowrap'
										}}>
										<div
											style={{
												width: '13px',
												height: '13px',
												border: '1px solid black',
												borderRadius: '60%',
												padding: '1px',
												marginRight: '8px'
											}}>
											<div
												style={{
													backgroundColor: banks[i].isClicked
														? 'rgba(0,0,0,1)'
														: 'rgba(0,0,0,0)',
													height: '100%',
													width: '100%',
													borderRadius: '60%'
												}}></div>
										</div>
										{`${v.bank} (${v.account_number.slice(-4)})`}
									</div>
								) : (
									<img src={PlusCashout} width="10px" height="10px" alt="add a bank button" />
								)
							}
							type={v.type}
							onClick={() => {
								if (v.bank) handleCashoutChooseOption(v, i);
								if (!v.bank) {
									handleModal(i);
								}
							}}
							styleText={v.styleText}
						/>
					);
				})}
			<div
				style={{
					backgroundColor: '',
					marginTop: '16px',
					width: '60vw !important',
					whiteSpace: 'nowrap',
					color: '#888888',
					fontWeight: 400,
					fontSize: '10px',
					lineHeight: '10px',
					letterSpacing: '1.25px',
					display: 'flex',
					justifyContent: 'center'
				}}>
				<img
					src={ExclamationMarkCashout}
					alt="important"
					width="10px"
					height="10.51px"
					color="#888888"
					style={{ marginRight: '8px' }}
				/>
				You can link up to three (3) accounts only.
			</div>
			{addModal && <div style={overlay}></div>}
			{addModal && (
				<CashoutAddBankOptions
					setAddModal={setAddModal}
					bankAccounts={bankAccounts}
					setBankAccounts={setBankAccounts}
					addIndex={addIndex}
					classes={classes}
					setCurrentUser={setCurrentUser}
					currentUser={currentUser}
				/>
			)}
		</div>
	);
};

export default hot(module)(CashoutBankOptions);
